import get from "lodash/get";

import type { CarryTheme } from "../theme";

const getThemeValue =
  (path: string, fallback?: string | number) =>
  (theme: CarryTheme): string | number | undefined =>
    get(theme, path, fallback);

export default getThemeValue;
